import NetworkManagerMixin, { onError } from "@/utils/http/NetworkManagerMixin";
import IJsonResponse from "@/utils/types/IJsonResponse";
import { Component } from "vue-property-decorator";

@Component
export default class JackocoinsNetworkManagerMixin extends NetworkManagerMixin {
  @onError(401)
  handleError401(response: IJsonResponse) {
    this.$store.dispatch("clear");
    this.$router.replace("/login");
    toast({ message: "You are not authorized. Please sign in" });
  }
}
